import * as types from "../actions/Types";

const initialState = {};

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOGIN_CREDENTIALS:
      return Object.assign({}, state, {
        phoneNumber: action.phoneNumber,
        countryCode: action.countryCode,
        name: action.name,
        imageUrl: action.imageUrl,
        authToken: action.authToken,
        memberId: action.memberId,
        isAdmin: action.isAdmin,
        baseLocation: action.location,
        canSendFromLiveLocation: action.canSendFromLiveLocation,
      });
    case types.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
